module.exports = __webpack_public_path__ + "static/Lexroom-hero-a65db511908d1ea7804b073f8625e85f.png";